"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var Dialog_1 = require("@mui/material/Dialog");
var DialogTitle_1 = require("@mui/material/DialogTitle");
var DialogContent_1 = require("@mui/material/DialogContent");
var DialogActions_1 = require("@mui/material/DialogActions");
var Button_1 = require("@mui/material/Button");
var operators_1 = require("rxjs/operators");
var SetTemporaryPasswordAction = /** @class */ (function (_super) {
    __extends(SetTemporaryPasswordAction, _super);
    function SetTemporaryPasswordAction(props) {
        var _this = _super.call(this, props) || this;
        _this.openModalAndFillPassword = function () {
            _this.generatePassword();
            _this.toggleTemporaryPasswordPopupModal();
            _this.supportPortalService.logAgentActivity(_this.props.customerId, { "action": "No Action", "customer": "Account" }).subscribe(function (agentAction) { return _this.setState({ agentActivityId: agentAction.id }); });
        };
        _this.toggleTemporaryPasswordPopupModal = function () {
            _this.setState(function (prevState) { return ({
                showTemporaryPasswordPopup: !prevState.showTemporaryPasswordPopup
            }); });
        };
        _this.generatePassword = function () {
            var numbers = "0123456789";
            var uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            var lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
            var specialChars = "!@-#$%&*()";
            var allChars = numbers + uppercaseChars + lowercaseChars + specialChars;
            var generatedPassword = "";
            // One random number
            generatedPassword += _this.secureRandomChar(numbers);
            // One random uppercase char
            generatedPassword += _this.secureRandomChar(uppercaseChars);
            // One random lowercase char
            generatedPassword += _this.secureRandomChar(lowercaseChars);
            // One random special char
            generatedPassword += _this.secureRandomChar(specialChars);
            // Other 8 random chars
            for (var i = generatedPassword.length; i < 12; i++) {
                generatedPassword += _this.secureRandomChar(allChars);
            }
            // Shuffle securely
            generatedPassword = _this.secureShuffle(generatedPassword.split("")).join("");
            _this.setState({
                generatedPassword: generatedPassword
            });
        };
        _this.secureRandomChar = function (chars) {
            var array = new Uint32Array(1);
            var idx;
            var maxUnbiased = Math.floor(0xffffffff / chars.length) * chars.length;
            do {
                crypto.getRandomValues(array);
                idx = array[0];
            } while (idx >= maxUnbiased);
            return chars[idx % chars.length];
        };
        _this.secureShuffle = function (arr) {
            var _a;
            for (var i = arr.length - 1; i > 0; i--) {
                var array = new Uint32Array(1);
                var j = void 0;
                var maxUnbiased = Math.floor(0xffffffff / (i + 1)) * (i + 1);
                do {
                    crypto.getRandomValues(array);
                    j = array[0];
                } while (j >= maxUnbiased);
                j = j % (i + 1);
                _a = [arr[j], arr[i]], arr[i] = _a[0], arr[j] = _a[1];
            }
            return arr;
        };
        _this.copyPassword = function () {
            navigator.clipboard.writeText(_this.state.generatedPassword).then(function () {
                _this.setState({ passwordIsCopied: true });
                setTimeout(function () {
                    _this.setState({ passwordIsCopied: false });
                }, 4000);
            }).catch(function (err) {
                console.error('Failed to copy password: ', err);
            });
        };
        _this.setTemporaryPassword = function () {
            var _a;
            _this.props.showLoader();
            _this.supportPortalService
                .setPassword(_this.props.customerId, _this.state.generatedPassword, true)
                .pipe((0, operators_1.finalize)(function () {
                _this.props.hideLoader();
                _this.toggleTemporaryPasswordPopupModal();
            }))
                .subscribe();
            _this.supportPortalService.logAgentActivity(_this.props.customerId, { "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString(), "action": "Set temporary password", "customer": "Account" }).subscribe();
        };
        _this.state = {
            showTemporaryPasswordPopup: false,
            generatedPassword: "",
            passwordIsCopied: false
        };
        return _this;
    }
    SetTemporaryPasswordAction.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.state.showTemporaryPasswordPopup, onClose: this.toggleTemporaryPasswordPopupModal, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { className: "close btn-outline-none text-right pt-1 pr-2", onClick: this.toggleTemporaryPasswordPopupModal, children: "x" }) }), (0, jsx_runtime_1.jsx)(DialogTitle_1.default, { id: "alert-dialog-title", className: "pt-0", children: "Generate temporary password" }), (0, jsx_runtime_1.jsxs)(DialogContent_1.default, { className: "pb-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", readOnly: true, value: this.state.generatedPassword }), (0, jsx_runtime_1.jsx)("i", { title: "Regenerate password", className: "icon-button fas fa-sync-alt ml-2", id: "regeneratePassword", onClick: this.generatePassword }), (0, jsx_runtime_1.jsx)("i", { title: "Copy password", className: "icon-button fas ".concat(this.state.passwordIsCopied ? 'fa-file-check' : 'fa-copy', " ml-2"), id: "copyPassword", onClick: this.copyPassword })] }), (0, jsx_runtime_1.jsx)(DialogActions_1.default, { children: (0, jsx_runtime_1.jsx)(Button_1.default, { className: "btn btn-primary w-100", onClick: this.setTemporaryPassword, children: "Save password" }) })] }), (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: this.openModalAndFillPassword, children: "Set temporary password" })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], SetTemporaryPasswordAction.prototype, "supportPortalService", void 0);
    SetTemporaryPasswordAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR"),
        __metadata("design:paramtypes", [Object])
    ], SetTemporaryPasswordAction);
    return SetTemporaryPasswordAction;
}(React.Component));
exports.default = SetTemporaryPasswordAction;
//# sourceMappingURL=SetTemporaryPasswordAction.js.map